import { type Maybe } from "@oefr/utils/types"

type GetPaginatedNodesInput<TGetPaginatedNode> = {
    edges?: Maybe<Array<Maybe<{ node?: Maybe<TGetPaginatedNode>; cursor?: Maybe<string> }>>>
}

/**
 * Disregard pagination to get the actual nodes.
 *
 * @param pagination - Graphql pagination
 * @returns Array of relevant items
 */
export const getPaginatedNodes = <TGetPaginatedNode>(
    pagination?: Maybe<GetPaginatedNodesInput<TGetPaginatedNode>>
) => {
    // TODO handle better pagination with cursor
    return (
        pagination?.edges
            ?.filter(Boolean)
            .map((e) => e.node)
            .filter(Boolean) || []
    )
}
